<template>
  <div id="select-online-or-offline">
    <div class="send-selects content-box">
      <div class="item-box" :class="{'active': currentItem === 1}" @click="selectType(1)">
        <div class="item-prompt">89%同业的选择</div>
        <div class="item-explain">
          <h5>在线上传资料</h5>
          <p>快速上传资料, 随时修改, 高效办理</p>
        </div>
      </div>
      <div class="item-box item-box-offline" :class="{'active': currentItem === 2, 'not-choice': !supportOffline}" @click="selectType(2)">
        <div class="item-not-choice-prompt" v-if="!supportOffline">该商品不支持</div>
        <div class="item-explain">
          <h5>线下邮寄资料</h5>
          <p>资料邮寄，办理时间长</p>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <button class="btn next" @click="nextStep()">下一步</button>
    </div>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';

export default {
  name: 'selectOnlineOrOffline',
  props: {
    supportOffline: {
      type: Boolean,
      default: false,
      required: true,
    },
    product: Object,
  },
  data() {
    return {
      currentItem: 1,
    };
  },
  created() {

  },
  methods: {
    init() {
      // 初始化当前选择的方式值
      // 若该商品【线上提交】资料中，包含邮寄资料，则默认资料递交方式为【线下邮寄】
      if (this.supportOffline && this.product) {
        // this.product
      }
    },
    // 选择方式
    selectType(type) {
      if (!this.supportOffline) {
        return;
      }
      if (type !== this.currentItem) {
        // 说明切换了，则上报埋点
        sensorsdata.track('LineClick', {
          click_module: 'order',
          line_result: type === 1 ? 'online' : 'offline',
        });
      }
      this.currentItem = type;
    },

    // 下一步
    nextStep() {
      if (this.currentItem === 1) {
        this.onlineUploadMaterial();
      } else if (this.currentItem === 2) {
        this.offlinePostMaterial();
      }
    },

    offlinePostMaterial() {

      // 线下邮寄资料流程但是商品不支持线下订单时
      if (!this.supportOffline) {
        return;
      }
      this.$emit('offlinePostMaterial', 3);
    },
    onlineUploadMaterial() {
      this.$emit('onlineUploadMaterial');
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variable";
#select-online-or-offline {
  padding-top: 30px;
  background-color: white;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  .content-box {
    display: flex;
    justify-content: center;
    align-items: center;
    .item-box {
      box-sizing: border-box;
      width: 350px;
      height: 120px;
      border:1px solid rgba(222,226,230,1);
      border-radius: 4px;
      padding: 36px 0 36px 100px;
      position: relative;
      background: url('../../assets/imgs/order/icon-在线上传-2@2x.png') no-repeat 38px 36px;
      background-size: 48px 48px;
      cursor: pointer;
      .item-prompt {
        position: absolute;
        top: -1px;
        left: -1px;
        color: #ffffff;
        font-size: 12px;
        line-height: 20px;
        padding-left: 8px;
        width: 120px;
        background: url('../../assets/imgs/order/item-bg-sign.png') no-repeat 0 0;
        background-size: 110px 20px;
      }
      .item-explain {
        display: flex;
        flex-flow: column;
        h5 {
          font-size: 18px;
          margin: 0;
          line-height: 1;
          font-weight: 400;
          color: #2F333D;
        }
        p{
          font-size: 14px;
          margin: 0;
          line-height: 1;
          padding-top: 8px;
          color: #91999F;
        }
      }
      &.active {
        background-image: url('../../assets/imgs/order/icon-在线上传-1@2x.png'), url('../../assets/imgs/order/icon-勾选@2x.png');
        background-repeat: no-repeat, no-repeat;
        background-size: 48px 48px, 32px 32px;
        background-position: 38px 36px, right -1px bottom -1px;
        border-color: #599FFF;
        .item-explain {
          h5 {
            color: #599FFF;
          }
          p{
            color: #599FFF;
          }
        }
      }
      &.not-choice {
        cursor: not-allowed;
        background-color: rgba(250,251,252,1);
        .item-explain {
          h5 {
            color: #C9CDD1;
          }
          p{
            color: #C9CDD1;
          }
        }
      }
    }
    .item-box-offline {
      width: 250px;
      padding-left: 90px;
      margin-left: 15px;
      background: url('../../assets/imgs/order/icon-线下邮寄-2@2x.png') no-repeat 28px 36px;
      background-size: 48px 48px;
      &.active {
        background-image: url('../../assets/imgs/order/icon-线下邮寄-1@2x.png'), url('../../assets/imgs/order/icon-勾选@2x.png');
        background-position: 28px 36px, right -1px bottom -1px;
      }
      .item-not-choice-prompt {
        color: #91999F;
        padding: 4px 8px;
        font-size:12px;
        line-height: 1;
        background: #E9EEF2;
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
  .bottom-box {
    padding-top: 32px;
    text-align: center;
    .next {
      width:162px;
      height:48px;
      background:rgba(89,159,255,1);
      border-radius:4px;
      border: 1px solid #5E9BE1;
      font-size:18px;
      color: #ffffff;
      cursor: pointer;
      outline: none;
      &:hover{
        opacity: 0.9;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/add-order/select-online-or-offline.vue